export default __webpack_public_path__ + "static/media/graignes8.222e7cce.jpg";